/**
 * Action Creators for ui reducer
 * */

export const ActionTypes = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
}

export function toggle(key, show) {
  return {
    type: show ? ActionTypes.SHOW : ActionTypes.HIDE,
    key,
  }
}
